<template>
  <div id="app">
    <div id="nav">
      <router-link to="/home">Home</router-link> |
      <router-link to="/submissions">Submissions</router-link>
    </div>
    <router-view @clicked="onClickEvent"> </router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userData: [
        {
          firstname: "Justin",
          lastname: "Jung",
          email: "justin@gmail.com",
          mobile: "91234567",
          mainAddress: "123 Tampines Street 12",
          secAddress: "#02-34",
          nationalitySelected: "Singaporean",
          postalCode: "123456",
          professionSelected: "Underpaid Lab TA",
        },
      ],
    };
  },
  methods: {
    onClickEvent(value) {
      this.userData.push(value);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
